var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFpassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 818.55304,
    height: 686.94758,
    viewBox: "0 0 818.55304 686.94758",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.52602,
    y: 93.87406,
    width: 578.55461,
    height: 591.62109,
    rx: 17.3886,
    ry: 17.3886,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M657.83595,686.94758H129.77074c-14.72105,0-26.69724-11.97619-26.69724-26.69724V119.12007c0-14.72105,11.97619-26.69724,26.69724-26.69724h528.06521c14.71964,0,26.69582,11.97619,26.69582,26.69724v541.13027c0,14.72105-11.97619,26.69724-26.69582,26.69724ZM129.77074,95.32649c-13.12035,0-23.79358,10.67323-23.79358,23.79358v541.13027c0,13.12035,10.67323,23.79358,23.79358,23.79358h528.06521c13.11894,0,23.79216-10.67323,23.79216-23.79358V119.12007c0-13.12035-10.67323-23.79358-23.79216-23.79358H129.77074Z",
    fill: "#090814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M605.98545,368.99662H191.05814c-10.88873,0-19.74859-8.85985-19.74859-19.74859v-65.03607c0-10.88873,8.85985-19.74717,19.74859-19.74717h414.92732c10.88873,0,19.74717,8.85844,19.74717,19.74717v65.03607c0,10.88873-8.85844,19.74859-19.74717,19.74859ZM191.05814,267.36845c-9.28803,0-16.84492,7.55548-16.84492,16.84351v65.03607c0,9.28803,7.55689,16.84492,16.84492,16.84492h414.92732c9.28803,0,16.84351-7.55689,16.84351-16.84492v-65.03607c0-9.28803-7.55548-16.84351-16.84351-16.84351H191.05814Z",
    fill: "#090814"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M605.98545,495.30591H191.05814c-10.88873,0-19.74859-8.85985-19.74859-19.74859v-65.03607c0-10.88873,8.85985-19.74717,19.74859-19.74717h414.92732c10.88873,0,19.74717,8.85844,19.74717,19.74717v65.03607c0,10.88873-8.85844,19.74859-19.74717,19.74859ZM191.05814,393.67774c-9.28803,0-16.84492,7.55548-16.84492,16.84351v65.03607c0,9.28803,7.55689,16.84492,16.84492,16.84492h414.92732c9.28803,0,16.84351-7.55689,16.84351-16.84492v-65.03607c0-9.28803-7.55548-16.84351-16.84351-16.84351H191.05814Z",
    fill: "#090814"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 295.44178,
    cy: 443.76531,
    r: 10.16282,
    fill: "#207567"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.55981,
    cy: 444.49122,
    r: 10.16282,
    fill: "#207567"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 364.40375,
    cy: 443.03939,
    r: 10.16282,
    fill: "#207567"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 399.24769,
    cy: 443.03939,
    r: 10.16282,
    fill: "#207567"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 434.09164,
    cy: 443.03939,
    r: 10.16282,
    fill: "#207567"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.93558,
    cy: 443.03939,
    r: 10.16282,
    fill: "#207567"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M489.98785,630.32618h-197.45042c-26.01811,0-47.1845-21.16639-47.1845-47.1845s21.16639-47.1845,47.1845-47.1845h197.45042c26.0167,0,47.18309,21.16639,47.18309,47.1845s-21.16639,47.1845-47.18309,47.1845Z",
    fill: "#207567"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.78908,145.85152c-6.16745,0-11.59054-4.41929-12.77583-10.53428L.23907,17.85221c-.73159-3.77419.23394-7.65472,2.64846-10.64629,2.4131-2.99015,6.00156-4.7539,9.84523-4.83613L122.78551.00348c6.4269-.14603,11.87411,4.31438,13.06222,10.58532l21.58464,113.91485c.69756,3.68629-.22827,7.49309-2.54354,10.44638-2.31386,2.95187-5.78889,4.7624-9.53331,4.96515l-108.86321,5.91649c-.23536.01276-.47071.01985-.70323.01985Z",
    fill: "#d6d6e3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "28.66713 126.81449 52.62234 62.20802 92.54769 91.97055 105.61417 78.90407 151.34684 126.08858 28.66713 126.81449",
    fill: "#207567"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.71083,56.40088c-6.0044,0-10.88873-4.88433-10.88873-10.88873s4.88433-10.88873,10.88873-10.88873,10.88873,4.88433,10.88873,10.88873-4.88433,10.88873-10.88873,10.88873Z",
    fill: "#207567"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.86385,589.556c-3.43108,0-6.78703-1.0038-9.7233-2.9462-4.01238-2.65696-6.71897-6.72322-7.61786-11.45018L.52831,459.55191c-1.79069-9.41705,4.12864-18.4513,13.47622-20.56666l98.53168-22.31906c4.67592-1.05626,9.46526-.21125,13.49182,2.38049,4.0294,2.59458,6.78135,6.60838,7.74971,11.29989l23.97364,116.13796c1.95373,9.46384-4.13999,18.82701-13.58256,20.87432l-100.51235,21.78739c-1.26185.27364-2.5322.40975-3.79262.40975Z",
    fill: "#d6d6e3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.29136,485.41832c-2.39892,0-4.53272-1.70562-4.98925-4.14991-.51608-2.75905,1.30296-5.41317,4.06201-5.92784l79.65788-14.88127c2.75763-.52317,5.41176,1.30296,5.92784,4.06201s-1.30296,5.41317-4.06201,5.92784l-79.65788,14.88127c-.31475.05955-.6295.0879-.93859.0879Z",
    fill: "#090814"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.55193,515.90677c-2.29968,0-4.38243-1.57093-4.93963-3.90605-.64935-2.72927,1.03641-5.46989,3.7671-6.12066l74.9848-17.8544c2.72785-.64652,5.46847,1.03641,6.12066,3.7671.64935,2.72927-1.03641,5.46989-3.7671,6.12066l-74.9848,17.8544c-.39557.09358-.79113.13894-1.18103.13894Z",
    fill: "#090814"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.63192,545.40559c-2.3493,0-4.45899-1.63898-4.96515-4.0294-.5813-2.74629,1.17252-5.44295,3.91739-6.02425l51.15719-10.83344c2.76046-.57988,5.44437,1.17252,6.02425,3.91739.5813,2.74629-1.17252,5.44295-3.91739,6.02425l-51.15719,10.83344c-.35587.07514-.71032.11201-1.0591.11201Z",
    fill: "#090814"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M781.29999,233.8872c-.90314,0-1.81621-.07089-2.73353-.21409l-101.60264-15.94037c-4.75531-.74718-8.90664-3.31908-11.69121-7.24498-2.78457-3.92448-3.84083-8.69397-2.97455-13.4266l21.19616-115.75658c1.72972-9.42839,10.50167-15.70359,19.98961-14.32123l99.94807,14.7324c4.73972.69898,8.90381,3.217,11.72382,7.09044,2.82143,3.87202,3.94008,8.60749,3.15036,13.33303l-19.54159,116.96596c-1.43765,8.61457-8.97895,14.78202-17.4645,14.78202Z",
    fill: "#d6d6e3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M785.29395,132.09174c-.30908,0-.62242-.02836-.93717-.0879l-79.66355-14.86c-2.75905-.51466-4.57809-3.16737-4.06343-5.92642.51324-2.75905,3.16028-4.58943,5.92642-4.06343l79.66355,14.86c2.75905.51466,4.57809,3.16737,4.06343,5.92642-.45511,2.44429-2.59033,4.15133-4.98925,4.15133Z",
    fill: "#090814"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M777.77959,158.68548c-.22968,0-.45937-.01418-.69331-.04679l-76.37708-10.40101c-2.78031-.37855-4.72696-2.93911-4.3484-5.72084.37997-2.78173,2.94903-4.72979,5.72084-4.3484l76.37708,10.40101c2.78031.37855,4.72696,2.93911,4.3484,5.72084-.34736,2.54779-2.52653,4.39519-5.02753,4.39519Z",
    fill: "#090814"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M747.11817,185.98529c-.26938,0-.54302-.02268-.81807-.06664l-51.62081-8.3537c-2.77039-.44803-4.65181-3.0582-4.20379-5.82859.44944-2.77039,3.04119-4.64614,5.82859-4.20379l51.62081,8.3537c2.77039.44803,4.65181,3.0582,4.20379,5.82859-.40407,2.49533-2.56055,4.27042-5.01052,4.27042Z",
    fill: "#090814"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpassword);
export default __webpack_public_path__ + "static/media/fpassword.9e88d6c8cd2e305a8fa4dc976b1710c7.svg";
export { ForwardRef as ReactComponent };